import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { HealthPage } from 'features/health'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/health/')({
  component: HealthPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Health'),
      },
    ],
  }),
  beforeLoad: protectWithWorkspacePermissions(canViewConfigurationPermission),
})
